"use client"

import {store} from "@/core/redux/store";
import {Provider} from "react-redux";
import MenuTabComponent from "@/core/menu/menuTab.component";
import {useEffect} from "react";

export default function MenuTabContainerComponent() {

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            if (typeof window !== 'undefined')
                window.addEventListener('load', function () {
                    navigator.serviceWorker.register('/sw.js', {scope: '/'}).then(
                        function (registration) {
                            console.log('Service Worker registration successful with scope: ', registration.scope);
                        },
                        function (err) {
                            console.log('Service Worker registration failed: ', err);
                        }
                    );
                });
        }
    }, []);

    return (
        <Provider store={store}>
            <MenuTabComponent/>
        </Provider>
    )

}